<template>
	<v-container grid-list-md>
		<v-form>
			<v-card>
				<v-card-title primary-title>
					<v-btn
						icon
						@click="
							$inertia.visit(
								$route(
									'tenant.reservations.index',
									$page.props.tenant.id
								)
							)
						"
					>
						<v-icon>mdi-arrow-left</v-icon>
					</v-btn>
					{{ $t("title.create_reservation") }}
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-layout row wrap>
						<v-flex xs12>
							<v-card>
								<v-card-title primary-title>
									Customer
									<v-spacer></v-spacer>
									<CustomerCreateForm
										@onSuccess="getCustomers()"
									></CustomerCreateForm>
								</v-card-title>
								<v-divider></v-divider>
								<v-card-text>
									<v-btn-toggle
										v-model="item.customer_type"
										tile
										group
										mandatory
										color="deep-purple accent-3"
									>
										<v-btn value="guest" ma-0>
											{{ $__("Guest") }}
										</v-btn>

										<v-btn value="customer" ma-0>
											{{ $__("Customer") }}
										</v-btn>
									</v-btn-toggle>
									<v-layout
										row
										wrap
										class="blue-grey lighten-5 pa-5"
										v-if="item.customer_type == 'guest'"
									>
										<v-flex xs12 md6>
											<ValidationProvider
												name="first_name"
												rules=""
												v-slot="{ errors }"
											>
												<v-text-field
													v-model="
														item.customer.first_name
													"
													:label="$__('First Name')"
													prepend-inner-icon="mdi-account"
													dense
													:error-messages="errors"
												>
												</v-text-field>
											</ValidationProvider>
										</v-flex>
										<v-flex xs12 md6>
											<ValidationProvider
												name="last_name"
												rules=""
												v-slot="{ errors }"
											>
												<v-text-field
													v-model="
														item.customer.last_name
													"
													:label="$__('Last Name')"
													prepend-inner-icon="mdi-account"
													dense
													:error-messages="errors"
												>
												</v-text-field>
											</ValidationProvider>
										</v-flex>
										<v-flex xs12 md12>
											<ValidationProvider
												name="email"
												rules="email"
												v-slot="{ errors }"
											>
												<v-text-field
													v-model="
														item.customer.email
													"
													:label="$__('Email')"
													prepend-inner-icon="mdi-email"
													dense
													:error-messages="errors"
												>
												</v-text-field>
											</ValidationProvider>
										</v-flex>
										<v-flex xs12 md12>
											<ValidationProvider
												name="phone"
												rules="phone"
												v-slot="{ errors }"
											>
												<vue-tel-input-vuetify
													v-model="
														item.customer.phone
													"
													mode="international"
													:preferredCountries="['KH']"
													:placeholder="null"
													:label="
														$__(
															'label.phone_number'
														)
													"
													validate-on-blur
													required
													:error-messages="errors"
												></vue-tel-input-vuetify>
											</ValidationProvider>
										</v-flex>
									</v-layout>
									<ReservationCustomerForm
										v-if="item.customer_type == 'customer'"
										v-model="item"
										:customers="customers"
									>
									</ReservationCustomerForm>
								</v-card-text>
							</v-card>
						</v-flex>
						<v-flex xs12 class="my-3">
							<v-card>
								<v-card-text>
									<form-reservation
										v-model="item"
										:outlets="outlets"
										:customers="customers"
										:statuses="statuses"
										:adults="adults"
										:children="children"
										:tables="tables"
									></form-reservation>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						@click.native="submit()"
						:loading="item.processing"
					>
						<v-icon left>mdi-content-save</v-icon>
						{{ $t("Save") }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-container>
</template>
<script>
import CustomerCreateForm from "@Reservation/components/CustomerCreateForm.vue";
import ReservationCustomerForm from "@Reservation/components/ReservationCustomerForm.vue";
export default {
	components: {
		CustomerCreateForm,
		ReservationCustomerForm,
	},
	props: ["outlets", "customers", "statuses", "adults", "children", "tables"],
	data() {
		return {
			item: this.$inertia.form({
				customer_id: null,
				outlet_id: null,
				adults: 1,
				children: 0,
				date: null,
				time: null,
				description: null,
				status: "pending",
				table_id: null,
				customer: {},
				customer_type: "guest",
				options: {
					table_ids: [],
				},
			}),
		};
	},
	methods: {
		submit() {
			this.item.post(
				this.$route(
					"tenant.reservations.store",
					this.$page.props.tenant.id
				)
			);
		},

		getCustomers() {
			this.$inertia.reload({
				only: ["customers"],
			});
		},
	},
};
</script>
